import React from "react";
import "../css/paymentmodal.css";
const PaymentSummery = () => {
  return (
    <div className="payment">
      <div className="f600-16px">Payment Summary</div>
      <div className="d-flex justify-content-between">
        <div className="f400-16px">Registration Charge</div>
        <div className="f600-16px">Rs 150</div>
      </div>
      <div className="d-flex justify-content-between">
        <div className="f400-16px">Consultation Charge</div>
        <div className="f600-16px">Rs 1200</div>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <div className="f400-16px">Net Payable amount</div>
        <div className="f600-16px">Rs 1350</div>
      </div>
    </div>
  );
};

export default PaymentSummery;
